@if (user()) {
	<div>
		<a routerLink="/help.do?currentTopic=homepage/impressum">
			{{"frame.footer.impressum" | msgKeyCached}}
		</a>
	</div>
} @else {
	@if ('showLinkToImpressumBeforeLogin' | feature | async) {
		<div>
			<a routerLink="/help.do?currentTopic=homepage/impressum">
				{{"frame.footer.impressum" | msgKeyCached}}
			</a>
		</div>
	}
}
